import { LiaFacebook } from "react-icons/lia";
import { ENGLISH, SPANISH } from "../../utils/constants";
import { ROUTES } from "../../utils/routes";

export const footerDescription = {
  [SPANISH]: `
      Cada viaje es una oportunidad para descubrir, explorar y crear recuerdos
      inolvidables. Cartagena de Indias es un lugar perfecto para conocer y
      disfrutar de todas las maravillas que contiene esta bella ciudad.
    `,
  [ENGLISH]: `
      Every trip is an opportunity to discover, explore and create unforgettable
      memories. Cartagena de Indias is a perfect place to discover and enjoy all
      the wonders that this beautiful city contains.
  `,
};

export const usefulLinks = {
  [SPANISH]: "Links útiles",
  [ENGLISH]: "Useful links",
};

export const usefulLinksItems = {
  [SPANISH]: [
    {
      link: ROUTES.HOME,
      label: "Inicio",
    },
    {
      link: ROUTES.CONTACTUS,
      label: "Contáctenos",
    },
    {
      link: ROUTES.ABOUTUS,
      label: "Sobre Nosotros",
    },
    // {
    //   link: ROUTES.FREQUENTQUESTIONS,
    //   label: "Preguntas Frecuentes",
    // },
  ],
  [ENGLISH]: [
    {
      link: ROUTES.HOME,
      label: "Home",
    },
    {
      link: ROUTES.CONTACTUS,
      label: "Contact Us",
    },
    {
      link: ROUTES.ABOUTUS,
      label: "About Us",
    },
    // {
    //   link: ROUTES.FREQUENTQUESTIONS,
    //   label: "Frequents Questions",
    // },
  ],
};

export const ourSocialMedia = {
  [SPANISH]: "Redes sociales",
  [ENGLISH]: "Social media",
};

export const ourSocialMediaItems = [
  {
    link: "https://www.facebook.com/JohnJowyTravelsNTours",
    icon: <LiaFacebook />,
  },
];

export const copyRightText = {
  [SPANISH]: <p>Todos los derechos reservados Jowy Travel & Tours @2023</p>,
  [ENGLISH]: <p>Copyright Jowy Travel & Tours @2023</p>,
};
